
<template>
	<footer class="footer">
		<div class="foot-container">
			<p>Say Hello: <a href="mailto:barredowlband@gmail.com" title="barredowlband@gmail.com">barredowlband@gmail.com</a></p>
		</div>
	</footer>
</template>

<script>
export default {
  name: "footerInc",
};
</script>